import type { DatasetResponse, ProjectResponse, SpaceResponse, ThreadResponse } from '~/api-client'

export const ONBOARDING_SPACE_ID = '__onboarding_grant_writing__'
export const ONBOARDING_ID_PREFIX = '__onboarding_'

const NOW = new Date().toISOString()
const MOCK_USER = 'onboarding_user'

// 6 Spaces
export const MOCK_SPACES: SpaceResponse[] = [
	{
		id: ONBOARDING_SPACE_ID,
		name: 'Grant Writing Workshop',
		createdAt: NOW,
		modifiedAt: NOW,
		owner: MOCK_USER,
	},
	{
		id: '__onboarding_hr__',
		name: 'HR & People Ops',
		createdAt: NOW,
		modifiedAt: NOW,
		owner: MOCK_USER,
	},
	{
		id: '__onboarding_procurement__',
		name: 'Procurement',
		createdAt: NOW,
		modifiedAt: NOW,
		owner: MOCK_USER,
	},
	{
		id: '__onboarding_risk__',
		name: 'Risk, Privacy & Compliance',
		createdAt: NOW,
		modifiedAt: NOW,
		owner: MOCK_USER,
	},
	{
		id: '__onboarding_research__',
		name: 'Research Grants',
		createdAt: NOW,
		modifiedAt: NOW,
		owner: MOCK_USER,
	},
	{
		id: '__onboarding_report__',
		name: 'UniMelb Annual Report',
		createdAt: NOW,
		modifiedAt: NOW,
		owner: MOCK_USER,
	},
]

// 7 Threads in Grant Writing Workshop space
export const MOCK_SPACE_THREADS: ThreadResponse[] = [
	{
		id: '__onboarding_thread_1__',
		threadName: 'EoI draft and positioning',
		spaceId: ONBOARDING_SPACE_ID,
		user: MOCK_USER,
		threadModifiedDatetime: NOW,
		project: 'playground',
	},
	{
		id: '__onboarding_thread_2__',
		threadName: 'Aims and research questions',
		spaceId: ONBOARDING_SPACE_ID,
		user: MOCK_USER,
		threadModifiedDatetime: NOW,
		project: 'playground',
	},
	{
		id: '__onboarding_thread_3__',
		threadName: 'Impact statement (draft + tighten)',
		spaceId: ONBOARDING_SPACE_ID,
		user: MOCK_USER,
		threadModifiedDatetime: NOW,
		project: 'playground',
	},
	{
		id: '__onboarding_thread_4__',
		threadName: 'Budget notes and justification',
		spaceId: ONBOARDING_SPACE_ID,
		user: MOCK_USER,
		threadModifiedDatetime: NOW,
		project: 'playground',
	},
	{
		id: '__onboarding_thread_5__',
		threadName: 'Partner letters and support wording',
		spaceId: ONBOARDING_SPACE_ID,
		user: MOCK_USER,
		threadModifiedDatetime: NOW,
		project: 'playground',
	},
	{
		id: '__onboarding_thread_6__',
		threadName: 'Plain language summary',
		spaceId: ONBOARDING_SPACE_ID,
		user: MOCK_USER,
		threadModifiedDatetime: NOW,
		project: 'playground',
	},
	{
		id: '__onboarding_thread_7__',
		threadName: 'Methods section polish',
		spaceId: ONBOARDING_SPACE_ID,
		user: MOCK_USER,
		threadModifiedDatetime: NOW,
		project: 'playground',
	},
]

// 19 Individual threads (no space)
export const MOCK_INDIVIDUAL_THREADS: ThreadResponse[] = [
	{ id: '__onboarding_ind_1__', threadName: 'Draft an email', user: MOCK_USER, threadModifiedDatetime: NOW, project: 'playground' },
	{ id: '__onboarding_ind_2__', threadName: 'Rewrite for clarity', user: MOCK_USER, threadModifiedDatetime: NOW, project: 'playground' },
	{ id: '__onboarding_ind_3__', threadName: 'Turn notes into a summary', user: MOCK_USER, threadModifiedDatetime: NOW, project: 'playground' },
	{ id: '__onboarding_ind_4__', threadName: 'Meeting agenda builder', user: MOCK_USER, threadModifiedDatetime: NOW, project: 'playground' },
	{ id: '__onboarding_ind_5__', threadName: 'Action items and next steps', user: MOCK_USER, threadModifiedDatetime: NOW, project: 'playground' },
	{ id: '__onboarding_ind_6__', threadName: 'Create a checklist', user: MOCK_USER, threadModifiedDatetime: NOW, project: 'playground' },
	{ id: '__onboarding_ind_7__', threadName: 'Brainstorm names', user: MOCK_USER, threadModifiedDatetime: NOW, project: 'playground' },
	{ id: '__onboarding_ind_8__', threadName: 'Brainstorm ideas', user: MOCK_USER, threadModifiedDatetime: NOW, project: 'playground' },
	{ id: '__onboarding_ind_9__', threadName: 'Make this sound more confident', user: MOCK_USER, threadModifiedDatetime: NOW, project: 'playground' },
	{ id: '__onboarding_ind_10__', threadName: 'Shorten to 3 options', user: MOCK_USER, threadModifiedDatetime: NOW, project: 'playground' },
	{ id: '__onboarding_ind_11__', threadName: "Explain like I'm busy", user: MOCK_USER, threadModifiedDatetime: NOW, project: 'playground' },
	{ id: '__onboarding_ind_12__', threadName: 'Pros, cons, and recommendation', user: MOCK_USER, threadModifiedDatetime: NOW, project: 'playground' },
	{ id: '__onboarding_ind_13__', threadName: 'Plan for the week', user: MOCK_USER, threadModifiedDatetime: NOW, project: 'playground' },
	{ id: '__onboarding_ind_14__', threadName: 'Decision memo draft', user: MOCK_USER, threadModifiedDatetime: NOW, project: 'playground' },
	{ id: '__onboarding_ind_15__', threadName: 'Slide outline', user: MOCK_USER, threadModifiedDatetime: NOW, project: 'playground' },
	{ id: '__onboarding_ind_16__', threadName: 'Stakeholder update', user: MOCK_USER, threadModifiedDatetime: NOW, project: 'playground' },
	{ id: '__onboarding_ind_17__', threadName: 'Risk and assumptions log', user: MOCK_USER, threadModifiedDatetime: NOW, project: 'playground' },
	{ id: '__onboarding_ind_18__', threadName: 'FAQs and talking points', user: MOCK_USER, threadModifiedDatetime: NOW, project: 'playground' },
	{ id: '__onboarding_ind_19__', threadName: 'Polish this paragraph', user: MOCK_USER, threadModifiedDatetime: NOW, project: 'playground' },
]

// 9 Datasets
export const MOCK_DATASETS: DatasetResponse[] = [
	{
		id: '__onboarding_ds_1__',
		name: 'Student support requests / Feb 2026',
		datasetOwner: MOCK_USER,
		type: 'RAG',
		dataClassification: 'private',
		dataSourceConfiguration: { s3: { bucket: 'mock', folder: 'mock', maxSizeMb: 100 } },
		modifiedBy: MOCK_USER,
		modifiedDatetime: NOW,
		vectorConfiguration: { chunkSize: 512, chunkType: 'token' },
		queryConfiguration: { size: 5 },
	},
	{
		id: '__onboarding_ds_2__',
		name: 'HR Policy Changes',
		datasetOwner: MOCK_USER,
		type: 'RAG',
		dataClassification: 'private',
		dataSourceConfiguration: { s3: { bucket: 'mock', folder: 'mock', maxSizeMb: 100 } },
		modifiedBy: MOCK_USER,
		modifiedDatetime: NOW,
		vectorConfiguration: { chunkSize: 512, chunkType: 'token' },
		queryConfiguration: { size: 5 },
	},
	{
		id: '__onboarding_ds_3__',
		name: 'Budget & Expense Report v2',
		datasetOwner: MOCK_USER,
		type: 'RAG',
		dataClassification: 'private',
		dataSourceConfiguration: { s3: { bucket: 'mock', folder: 'mock', maxSizeMb: 100 } },
		modifiedBy: MOCK_USER,
		modifiedDatetime: NOW,
		vectorConfiguration: { chunkSize: 512, chunkType: 'token' },
		queryConfiguration: { size: 5 },
	},
	{
		id: '__onboarding_ds_4__',
		name: 'Library Catalogue Metadata',
		datasetOwner: MOCK_USER,
		type: 'RAG',
		dataClassification: 'public',
		dataSourceConfiguration: { s3: { bucket: 'mock', folder: 'mock', maxSizeMb: 100 } },
		modifiedBy: MOCK_USER,
		modifiedDatetime: NOW,
		vectorConfiguration: { chunkSize: 512, chunkType: 'token' },
		queryConfiguration: { size: 5 },
	},
	{
		id: '__onboarding_ds_5__',
		name: 'Health Research Articles',
		datasetOwner: MOCK_USER,
		type: 'RAG',
		dataClassification: 'public',
		dataSourceConfiguration: { s3: { bucket: 'mock', folder: 'mock', maxSizeMb: 100 } },
		modifiedBy: MOCK_USER,
		modifiedDatetime: NOW,
		vectorConfiguration: { chunkSize: 512, chunkType: 'token' },
		queryConfiguration: { size: 5 },
	},
	{
		id: '__onboarding_ds_6__',
		name: 'Global Climate Reports',
		datasetOwner: MOCK_USER,
		type: 'RAG',
		dataClassification: 'public',
		dataSourceConfiguration: { s3: { bucket: 'mock', folder: 'mock', maxSizeMb: 100 } },
		modifiedBy: MOCK_USER,
		modifiedDatetime: NOW,
		vectorConfiguration: { chunkSize: 512, chunkType: 'token' },
		queryConfiguration: { size: 5 },
	},
	{
		id: '__onboarding_ds_7__',
		name: 'Historical Census Data',
		datasetOwner: MOCK_USER,
		type: 'RAG',
		dataClassification: 'public',
		dataSourceConfiguration: { s3: { bucket: 'mock', folder: 'mock', maxSizeMb: 100 } },
		modifiedBy: MOCK_USER,
		modifiedDatetime: NOW,
		vectorConfiguration: { chunkSize: 512, chunkType: 'token' },
		queryConfiguration: { size: 5 },
	},
	{
		id: '__onboarding_ds_8__',
		name: 'UniMelb Undergraduate Courses',
		datasetOwner: MOCK_USER,
		type: 'RAG',
		dataClassification: 'public',
		dataSourceConfiguration: { s3: { bucket: 'mock', folder: 'mock', maxSizeMb: 100 } },
		modifiedBy: MOCK_USER,
		modifiedDatetime: NOW,
		vectorConfiguration: { chunkSize: 512, chunkType: 'token' },
		queryConfiguration: { size: 5 },
	},
	{
		id: '__onboarding_ds_9__',
		name: 'HR Policy Changes',
		datasetOwner: MOCK_USER,
		type: 'RAG',
		dataClassification: 'private',
		dataSourceConfiguration: { s3: { bucket: 'mock', folder: 'mock', maxSizeMb: 100 } },
		modifiedBy: MOCK_USER,
		modifiedDatetime: NOW,
		vectorConfiguration: { chunkSize: 512, chunkType: 'token' },
		queryConfiguration: { size: 5 },
	},
]

// 9 Projects
export const MOCK_PROJECTS: ProjectResponse[] = [
	{
		id: '__onboarding_proj_1__',
		name: 'Campus Connect',
		owner: MOCK_USER,
		modifiedDatetime: NOW,
		promptTemplates: { default: {} },
		llmConfiguration: { temperature: '0.7', modelId: 'gpt-4o' },
		projectType: 'RAG',
		status: 'DEVELOPMENT',
	},
	{
		id: '__onboarding_proj_2__',
		name: 'AskLearn: Adaptive AI Tutoring',
		owner: MOCK_USER,
		modifiedDatetime: NOW,
		promptTemplates: { default: {} },
		llmConfiguration: { temperature: '0.7', modelId: 'gpt-4o' },
		projectType: 'RAG',
		status: 'DEVELOPMENT',
	},
	{
		id: '__onboarding_proj_3__',
		name: 'Campus Sustainability Monitor',
		owner: MOCK_USER,
		modifiedDatetime: NOW,
		promptTemplates: { default: {} },
		llmConfiguration: { temperature: '0.7', modelId: 'gpt-4o' },
		projectType: 'RAG',
		status: 'DEVELOPMENT',
	},
	{
		id: '__onboarding_proj_4__',
		name: 'Literature Review Bot',
		owner: MOCK_USER,
		modifiedDatetime: NOW,
		promptTemplates: { default: {} },
		llmConfiguration: { temperature: '0.7', modelId: 'gpt-4o' },
		projectType: 'RAG',
		status: 'DEVELOPMENT',
	},
	{
		id: '__onboarding_proj_5__',
		name: 'Melbourne Transport Data',
		owner: MOCK_USER,
		modifiedDatetime: NOW,
		promptTemplates: { default: {} },
		llmConfiguration: { temperature: '0.7', modelId: 'gpt-4o' },
		projectType: 'RAG',
		status: 'DEVELOPMENT',
	},
	{
		id: '__onboarding_proj_6__',
		name: 'Automating Staff Policy Assistance',
		owner: MOCK_USER,
		modifiedDatetime: NOW,
		promptTemplates: { default: {} },
		llmConfiguration: { temperature: '0.7', modelId: 'gpt-4o' },
		projectType: 'RAG',
		status: 'DEVELOPMENT',
	},
	{
		id: '__onboarding_proj_7__',
		name: 'Student Success Tracker',
		owner: MOCK_USER,
		modifiedDatetime: NOW,
		promptTemplates: { default: {} },
		llmConfiguration: { temperature: '0.7', modelId: 'gpt-4o' },
		projectType: 'RAG',
		status: 'DEVELOPMENT',
	},
	{
		id: '__onboarding_proj_8__',
		name: 'Health Policy Explorer',
		owner: MOCK_USER,
		modifiedDatetime: NOW,
		promptTemplates: { default: {} },
		llmConfiguration: { temperature: '0.7', modelId: 'gpt-4o' },
		projectType: 'RAG',
		status: 'DEVELOPMENT',
	},
	{
		id: '__onboarding_proj_9__',
		name: 'Historical Archives Chat',
		owner: MOCK_USER,
		modifiedDatetime: NOW,
		promptTemplates: { default: {} },
		llmConfiguration: { temperature: '0.7', modelId: 'gpt-4o' },
		projectType: 'RAG',
		status: 'DEVELOPMENT',
	},
]

/** Check if an ID is a mock/onboarding ID */
export function isOnboardingId(id: string) {
	return id.startsWith(ONBOARDING_ID_PREFIX)
}
